/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { PAGE_OFFER } from '../../../config/pages';
import icons from '../../../data/icons';
import Link from '../../helpers/Link';

const API_URL = process.env.REACT_APP_CMS;

const OfferBox = ({
    t, openPage, language, offer, index, totalItems
}) => (
    <Link
      openPage={ openPage }
      language={ language }
      page={ PAGE_OFFER }
      subpage={ offer.translations.slug }
      className={ cx(
        'offer-box',
        { 'container-2': totalItems === 2 },
        { 'container-3': totalItems >= 3 && totalItems % 3 === 0 },
        { 'container-4': totalItems >= 3 && totalItems % 3 === 1 },
        { 'container-5': totalItems >= 3 && totalItems % 3 === 2 }
        )
      }
      id={ `offer-box-${ index }` }
    >
        <span className="offer-box-icon" id={ `offer-box-icon-${ index }` }>
            <img className="offer-box-icon-src" src={ `${ API_URL }/assets/${ offer.icon }` } alt={ offer.translations.name }/>
        </span>
        <span className="offer-box-header" id={ `offer-box-header-${ index }` }>
            <span className="offer-box-title" id={ `offer-box-title-${ index }` }>{ offer.translations.name }</span>
            <span className="offer-box-subtitle" id={ `offer-box-subtitle-${ index }` }>{ offer.translations.short_description }</span>
        </span>
        <span className="offer-box-more" id={ `offer-box-more-${ index }` }>
            <span className="offer-box-more-text" id={ `offer-box-more-text-${ index }` }>{ t('offer.general.read_more') }</span>
            <span
              className="offer-box-more-icon"
              id={ `offer-box-more-icon-${ index }` }
              dangerouslySetInnerHTML={ { __html: icons.offer.arrowRight } }
            />
        </span>
    </Link>
);

OfferBox.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    offer: PropTypes.shape().isRequired,
    index: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired
};

export default OfferBox;



// WEBPACK FOOTER //
// ./src/components/content/offer/OfferBox.jsx